import { Injectable, NgZone } from '@angular/core';
import { IgenomicsState } from '../../../../core/interfaces/genomics-state.interface';
import { Store } from '@ngrx/store';
import { WORKFLOW_ACTIONS } from '../constants/WorkflowActions';
import { WorkflowBarService } from './workflow-bar.service';
import { Observable } from 'rxjs';

@Injectable()
export class WorkflowBarActionsCreatorService {
  private store$: any;
  private inprogress: Map<string, any> = new Map();

  constructor(store: Store<IgenomicsState>,
              private workflowBar: WorkflowBarService,
              private _zone: NgZone) {
    this.store$ = store.select('shared');
  }

  public setWorkflowBar(workflowId: string, revisionId: string, force: boolean = false, delay: number = 1) {
    return Promise.resolve();
    // return new Promise((resolve, reject) => {
    //   if (this.inprogress.has('workflowbar')) return resolve();
    //   this._zone.runOutsideAngular(() => {
    //     this.inprogress.set('workflowbar', true);
    //     setTimeout(() => {
    //       this.store$.take(1)
    //         .filter(state => {
    //           if (!(state.workflow_bar && state.workflow_status) || force)
    //             return true;
    //           else {
    //             this.inprogress.delete('workflowbar');
    //             return false;
    //           }
    //
    //         })
    //         .do(() => this.initWorkflowBar())
    //         .flatMap(res => this.workflowBar.getWorkflowBarItems(workflowId, revisionId))
    //         .finally(() => {
    //           this.inprogress.delete('workflowbar');
    //         })
    //         .catch((err) => {
    //           resolve();
    //           return Observable.empty();
    //         })
    //         .subscribe(response => {
    //           if (!response)
    //             return resolve();
    //           this.updateWorkflowBar(response.currentStatus, response.items);
    //           resolve(response);
    //         })
    //     }, delay)
    //   })
    // })

  }

  public getState(...levels: string[]) {
    let store = this.store$;
    levels.forEach(level => store = store.select(level));
    return store;
  }

  public updateWorkflowBar(workflow_status, workflow_bar) {
    this.store$.dispatch({
      type: WORKFLOW_ACTIONS.UPDATE_BAR,
      payload: { workflow_bar, workflow_status}
    });
  }

  public initWorkflowBar() {
    this.store$.dispatch({
      type: WORKFLOW_ACTIONS.INIT_BAR
    });
  }

}
